import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

export enum RecordingStatus {
  Init,
  Recording,
  RecordingDone,
}

export interface IVideoRecordingStore {
  status: RecordingStatus
  isSharing: boolean
}

export const useVideoRecordingStore = create<IVideoRecordingStore>()(
  subscribeWithSelector<IVideoRecordingStore>((_): IVideoRecordingStore => ({
    status: RecordingStatus.Init,
    isSharing: false,
  })),
)
